export function wrapSubmitInput(input) {
  const existingWrap = input.closest('.btn-loading-wrap');
  if (existingWrap) return existingWrap;

  const wrap = document.createElement('span');
  wrap.className = 'btn-loading-wrap';
  input.parentNode.insertBefore(wrap, input);
  wrap.appendChild(input);
  return wrap;
}

export function activateButtonLoading(button) {
  if (!button || button.dataset.loadableLoading === 'true') return;

  button.dataset.loadableLoading = 'true';
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  button.classList.add('btn--loading');

  if (button.tagName === 'INPUT') {
    wrapSubmitInput(button).classList.add('btn--loading');
  }
}

export function deactivateButtonLoading(button) {
  if (!button || button.dataset.loadableLoading !== 'true') return;

  delete button.dataset.loadableLoading;
  button.removeAttribute('aria-busy');
  button.classList.remove('btn--loading');
  button.disabled = false;

  if (button.tagName === 'INPUT') {
    button.closest('.btn-loading-wrap')?.classList.remove('btn--loading');
  }
}
